import { CellCoordinates } from 'components/common-form/builder/form/node/field/Grid/GridField.model';
import { useAppSelector } from 'hooks/useAppSelector';
import { ProductGraph } from 'state/product-description/model';
import { getBatchFormFieldMetadata } from 'state/selectors';

export function useCellMetadata(
  coordinates: CellCoordinates | undefined,
  formIds: readonly string[],
  productDescription: ProductGraph | undefined,
) {
  const formIdForCol = coordinates ? formIds.at(coordinates.column) : undefined;
  const fieldsMetadata = useAppSelector(state =>
    formIdForCol ? getBatchFormFieldMetadata(state, formIdForCol) : undefined,
  );
  if (fieldsMetadata === undefined || coordinates === undefined) {
    return;
  }
  const nodeId = productDescription?.flatMap(blockNode => blockNode.children).at(coordinates.row)?.id;
  return nodeId ? fieldsMetadata[nodeId] : undefined;
}
